"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Option = function Option(props) {
  var _props$data = props.data,
      label = _props$data.label,
      isAutomaticallyDetected = _props$data.isAutomaticallyDetected,
      distance = _props$data.distance,
      description = _props$data.description,
      isClosed = _props$data.isClosed,
      destinationLabel = _props$data.destinationLabel;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react["default"].createElement(Title, {
    $isDetected: isAutomaticallyDetected,
    $isClosed: isClosed
  }, /*#__PURE__*/_react["default"].createElement("span", null, label)), (description || distance || isClosed) && /*#__PURE__*/_react["default"].createElement(Subtitle, {
    $isClosed: isClosed
  }, isClosed ? /*#__PURE__*/_react["default"].createElement("span", null, " \u041D\u0435\u0442 \u0432\u044B\u043B\u0435\u0442\u043E\u0432 ", destinationLabel, " ") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, description), !isAutomaticallyDetected && /*#__PURE__*/_react["default"].createElement(Distance, null, distance, " \u043A\u043C"))));
};

exports.Option = Option;

var Title = _styledComponents["default"].div.withConfig({
  displayName: "Option__Title",
  componentId: "sc-2y6y01-0"
})(["display:flex;align-items:center;font-size:16px;line-height:20px;font-weight:500;color:", ";"], function (_ref) {
  var $isClosed = _ref.$isClosed;
  return $isClosed ? '#919499' : '#17181a';
});

var Subtitle = _styledComponents["default"].div.withConfig({
  displayName: "Option__Subtitle",
  componentId: "sc-2y6y01-1"
})(["display:flex;justify-content:space-between;font-size:12px;line-height:16px;color:", ";gap:8px;"], function (_ref2) {
  var $isClosed = _ref2.$isClosed;
  return $isClosed ? '#FD6434' : '#919499';
});

var Distance = _styledComponents["default"].span.withConfig({
  displayName: "Option__Distance",
  componentId: "sc-2y6y01-2"
})(["white-space:nowrap;"]);